import { render, staticRenderFns } from "./BasicSettingsTab.vue?vue&type=template&id=592fa933&scoped=true"
import script from "./BasicSettingsTab.vue?vue&type=script&lang=js"
export * from "./BasicSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./BasicSettingsTab.vue?vue&type=style&index=0&id=592fa933&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592fa933",
  null
  
)

export default component.exports